import { render, staticRenderFns } from "./secondDingd-list.vue?vue&type=template&id=5c9bd767&scoped=true"
import script from "./secondDingd-list.vue?vue&type=script&lang=js"
export * from "./secondDingd-list.vue?vue&type=script&lang=js"
import style0 from "./secondDingd-list.vue?vue&type=style&index=0&id=5c9bd767&prod&scoped=true&lang=css"
import style1 from "./secondDingd-list.vue?vue&type=style&index=1&id=5c9bd767&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9bd767",
  null
  
)

export default component.exports